import React from "react";
import { getCoolingZoneWarningText } from "utils/singleZoneCooling";
import { formatLength } from "utils/displayMeasurements";
import FixedBanner from "components/FixedBanner";
import classes from "./styles.module.scss";

const ZoneWarnings = ({
    minPerimeterRequired = 0,
    warnings: {
        missingInteriorDoor = false,
        notFullyEnclosed = false,
    },
    displayUnits: {
        perimeterDisplayUnits = "m",
    },
}) => (
    <>
        {missingInteriorDoor && (
            <FixedBanner type="warning" className={classes.warningBanner}>
                <p>{getCoolingZoneWarningText("missingInteriorDoor")}</p>
            </FixedBanner>
        )}
        {notFullyEnclosed && (
            <FixedBanner type="warning" className={classes.warningBanner}>
                <p>
                    {getCoolingZoneWarningText("notFullyEnclosed")}
                    {" "}
                    {getCoolingZoneWarningText("minWallPerimeter", formatLength(minPerimeterRequired, perimeterDisplayUnits))}
                </p>
            </FixedBanner>
        )}
    </>
);

export default ZoneWarnings;
